@layer module {
.flow-panel {
            width: 100%;
            display: flex;
            flex-flow: column nowrap;
            align-items: center;
    }

.flow-panel-surface {
            width: 100%;
    }
} // layer module










@layer app {
.flow-panel {
            max-width: $size-500;
    }

.flow-panel-surface {
            padding: $size-30 $size-20;
            border-radius: $size-10;
    }

      @media (min-width: 540px) {
                .flow-panel-surface {
                        padding: $size-40 $size-50;
                    }
          }

.flow-panel-surface {
            background: var(--banky-white);
            border: 1px solid var(--flow-panel-border);
    }
} // layer app










@layer context {
.flow-panel-surface:global(.bank-transfer-content) {
            background: var(--bg-modal);
            border-color: var(--border-default);
    }

.flow-panel-surface:global(.scan-pay-success-surface) {
            width: 92vw;
            max-width: $size-500;
            padding: 0;
            border-color: var(--scan-pay-success-border);
    }

      @media (max-width: 640px) {
                .flow-panel-surface:global(.scan-pay-success-surface) {
                        margin-top: $size-30;
                    }
          }
} // layer context
